module.exports = __webpack_public_path__ + "img/mastercard.0391ae62.png";